var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Carwash")]),_c('button',{on:{"click":function($event){return _vm.carwashStore.turnOnBay(1)}}},[_vm._v("Turn On Bay 1")]),_vm._v(" For 10 minutes\n  "),_c('button',{on:{"click":function($event){return _vm.carwashStore.blink(1)}}},[_vm._v("Test Blink")])])
}
var staticRenderFns = []

export { render, staticRenderFns }